import { useNavigate } from "react-router-dom";
import { Box } from "@mui/system";
import GridTable from "../../table/gridTable";
import { useDispatch, useSelector } from "react-redux";
import { getCurrencySymbol } from "../../../Helper/getCurrencySymbol";
import useCurrency from "../../../hooks/useCurrency";
import Loader from "../../SharedLayouts/Loader";
import { useEffect, useState } from "react";
import { getInvestmentBookings } from "../../../store/actions/investment/getInvestmentBookings";

const InvestmentInterestTable = ({ investmentID, cycle }) => {
  const dispatch = useDispatch();
  const [bookings, setBookings] = useState([]);

  const investment = useSelector((state) => state?.investment?.investment);

  const [, getAmount] = useCurrency();
  const [pending, setPending] = useState(false);

  const handleRowClick = (params, event) => {
    const isIconClick = event.target.getAttribute("data-is-icon") === "true";

    if (!isIconClick) {
      navigate(`/user-management/${params?.row?.id}`);
    }
  };

  const navigate = useNavigate();

  const rows =
    bookings?.map((user) => ({
      id: user?.user_id,
      firstName: user?.name?.split(" ")[0],
      lastName: user?.name?.split(" ")[1],
      email: user?.email,
      amount:
        getCurrencySymbol(cycle?.currency || investment?.currency) +
        " " +
        getAmount(user.amount, 2),
      status: user?.status,
    })) || [];

  const columns = [
    {
      field: "id",
      headerName: "Member ID",
      width: 150,
    },

    {
      field: "firstName",
      headerName: "First Name",
      width: 150,
    },
    {
      field: "lastName",
      headerName: "Last Name",
      width: 150,
    },

    {
      field: "email",
      headerName: "Email",
      width: 300,
    },
    {
      field: "amount",
      headerName: "Amount",
      width: 150,
    },
    {
      field: "status",
      headerName: "Status",
      width: 150,
    },
  ];

  const filteredRows = rows;

  useEffect(() => {
    setPending(true);

    dispatch(
      getInvestmentBookings({
        id: investmentID,
        type:
          investment?.investment_category?.name == "Real Estate"
            ? "property"
            : "business",
        cb: (data) => {
          setBookings(data?.data);
          setPending(false);
        },
        failed: () => {
          setPending(false);
        },
      })
    );
  }, []);
  return (
    <div className="mt-10 mb-8">
      <div className="flex justify-between mb-8"></div>
      <div className="bg-white ">
        <Box sx={{ overflowX: "auto", width: "100%", cursor: "pointer" }}>
          {pending ? (
            <Loader />
          ) : filteredRows?.length < 1 ? (
            <div className="  p-5 text-center">No data</div>
          ) : (
            <GridTable
              type={"usersIntrested"}
              rows={filteredRows}
              columns={columns}
              handleRowClick={(params, event) => handleRowClick(params, event)}
            />
          )}
        </Box>
      </div>
    </div>
  );
};

export default InvestmentInterestTable;
